import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../services/AuthProvider';

const ProtectedRoute = () => {
  const user = localStorage.getItem("msadmin");
  const isEmployee = localStorage.getItem("isEmployee"); // Check if the user is an employee

  if (!user && !isEmployee) {
    // If there is no authenticated user or employee, redirect to login page
    return <Navigate to="/" />;
  }

  return <Outlet />;  // Render nested routes here
};

export default ProtectedRoute;
